// extracted by mini-css-extract-plugin
module.exports = {"back_button":"styles_back_button__zC8Al"};